<!-- Parallax banner -->
<ng-container *ngIf="item">
    <section class="pdp-parallax-banner-two" [style.background-image]="'url(' +  item?.media?.url + ')'">
        <h2 *ngIf="item?.largeTitle">{{item?.largeTitle}}</h2>
        <h3 *ngIf="item?.mediumTitle">{{item?.mediumTitle}}</h3>
        <h4 *ngIf="item?.smallTitle">{{item?.smallTitle}}</h4>
    </section>
</ng-container>
<!-- Parallax banner end -->